import { newRequest } from "std/api/newRequest";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";
import type { ApiRelForaPadraoResponse } from "../types/ApiRelForaPadrao";

export function apiRelLeiturasForaPadrao({ params }: { params: ApiRelatorioGetParams }): Promise<ApiRelForaPadraoResponse> {
	return newRequest({
		url: "Relatorio/LeiturasForaPadrao",
		type: "get",
		idpk: undefined,
		params,
	});
}
